import { createSlice } from "@reduxjs/toolkit"

export const productListSlice = createSlice({
	name: "product_list",
	initialState: {
		products: "",
		errors: [],
	},

	reducers: {
        getProducts: (state, action) => {
			state.products = action.payload
		},
		getProductList: (state, action) => {
			state.products = action.payload
		},
		getErrors: (state, action) => {
			state.errors = action.payload
		},
	},
})
export const {getProducts, getProductList, getErrors} = productListSlice.actions

export default productListSlice.reducer
